// I know that is not atencion but it is the best way to do it

const defaultNotasForm = {
	comercial: null,
	nota: '',
	cliente: null,
}

export default defaultNotasForm;
